import { render, staticRenderFns } from "./StartWorkflowAttributeForm.vue?vue&type=template&id=cc688728&scoped=true&"
import script from "./StartWorkflowAttributeForm.vue?vue&type=script&lang=js&"
export * from "./StartWorkflowAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkflowAttributeForm.vue?vue&type=style&index=0&id=cc688728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc688728",
  null
  
)

export default component.exports